import type { ProductToCompareT } from '../type/product/productComparison';
import { useState } from 'react';

import { reorderProductCodesAtom } from '@vs-shop/engine/atom/productsComparison/productsComparison';
import { useAtomSet } from '@effect/atom-react';

export function useDragAndDropProductsComparison(products: readonly ProductToCompareT[]) {
  const reorderProductCodes = useAtomSet(reorderProductCodesAtom);
  const [draggingIndex, setDraggingIndex] = useState<number | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);

  const handleDragStart = (index: number) => {
    setDraggingIndex(index);
  };

  const handleDragOver = (index: number) => {
    setDragOverIndex(index);
  };

  const handleDragEnd = () => {
    setDraggingIndex(null);
    setDragOverIndex(null);
  };

  const handleDrop = (fromIndex: number, toIndex: number) => {
    if (fromIndex === toIndex) {
      handleDragEnd();
      return;
    }

    const reorderProducts = [...products];
    const [movedProduct] = reorderProducts.splice(fromIndex, 1);
    if (!movedProduct) {
      handleDragEnd();
      return;
    }
    reorderProducts.splice(toIndex, 0, movedProduct);

    // Update cookie with new order - triggers re-render via atom reactivity
    const reorderedProductCodes = reorderProducts.map((p) => p.code);
    reorderProductCodes(reorderedProductCodes);

    handleDragEnd();
  };

  return {
    draggingIndex,
    dragOverIndex,
    handleDragStart,
    handleDragOver,
    handleDragEnd,
    handleDrop,
  };
}
